import { useEffect } from 'react';

export const UNSAVED_CHANGES_MESSAGE = 'Máte neuložené zmeny, ktoré budú stratené. Naozaj chcete odísť?';

export function confirmDiscardChanges(): boolean {
    return window.confirm(UNSAVED_CHANGES_MESSAGE);
}

/**
 * Warns before the browser tab is closed/refreshed, and traps the browser
 * back/forward button behind a confirm dialog, while `isDirty` is true.
 * In-app navigation (Link/button clicks) isn't covered here - guard those
 * call sites directly with `confirmDiscardChanges()`.
 */
export function useUnsavedChangesGuard(isDirty: boolean): void {
    useEffect(() => {
        if (!isDirty) return;

        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Push a duplicate history entry so the first back-press is intercepted
        // instead of immediately navigating away.
        window.history.pushState(null, '', window.location.href);
        const handlePopState = () => {
            if (confirmDiscardChanges()) {
                window.removeEventListener('popstate', handlePopState);
                window.history.go(-1);
            } else {
                window.history.pushState(null, '', window.location.href);
            }
        };
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('popstate', handlePopState);
        };
    }, [isDirty]);
}